var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFffTiktok(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_210_492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5999 18.0196C27.7082 18.0241 25.8629 17.4341 24.3247 16.333V24.0124C24.3242 25.4347 23.8894 26.823 23.0786 27.9915C22.2678 29.1601 21.1196 30.0533 19.7874 30.5516C18.4553 31.05 17.0028 31.1298 15.624 30.7803C14.2453 30.4309 13.0062 29.6689 12.0723 28.5961C11.1383 27.5234 10.5542 26.1911 10.3978 24.7774C10.2415 23.3638 10.5205 21.936 11.1976 20.6852C11.8746 19.4344 12.9173 18.42 14.1864 17.7778C15.4555 17.1356 16.8903 16.8961 18.2992 17.0914V20.9539C17.6545 20.7511 16.9622 20.7572 16.3212 20.9714C15.6802 21.1855 15.1232 21.5967 14.7299 22.1462C14.3365 22.6958 14.1268 23.3556 14.1308 24.0314C14.1348 24.7072 14.3522 25.3645 14.752 25.9093C15.1519 26.4542 15.7136 26.8588 16.3571 27.0654C17.0006 27.2719 17.6929 27.2699 18.3351 27.0595C18.9774 26.8492 19.5367 26.4413 19.9333 25.894C20.3299 25.3468 20.5434 24.6882 20.5434 24.0124V9H24.3247C24.322 9.31932 24.3488 9.6382 24.4046 9.95262V9.95262C24.536 10.6545 24.8092 11.3222 25.2075 11.9149C25.6058 12.5076 26.1208 13.0128 26.721 13.3996C27.575 13.9642 28.5762 14.2652 29.5999 14.265V18.0196Z",
    fill: "#EAB5DE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_210_492"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.25,
    height: 22,
    fill: "white",
    transform: "translate(10.35 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFffTiktok);
export default __webpack_public_path__ + "static/media/fff-tiktok.a26a5de06259c6dc2acd238948919eb2.svg";
export { ForwardRef as ReactComponent };